export type AlertType = 'info' | 'success' | 'warning' | 'danger';

export const ALERT_TYPE_ION_ICON_NAME: { [type in AlertType]: string } = {
  info: 'information-circle',
  success: 'checkmark-circle',
  warning: 'warning-outline',
  danger: 'alert-circle',
};
